import { Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { ScrollToTop } from './components/ui/ScrollToTop'
import './global.css'

// Lazy loading dos componentes
const Institucional = lazy(() => import('./pages/Institucional').then(module => ({ default: module.Institucional })))
const Controladoria = lazy(() => import('./pages/Controladoria').then(module => ({ default: module.Controladoria })))
const Empresarial = lazy(() => import('./pages/Empresarial').then(module => ({ default: module.Empresarial })))
const Tributario = lazy(() => import('./pages/Tributario').then(module => ({ default: module.Tributario })))
const Financeiro = lazy(() => import('./pages/Financeiro').then(module => ({ default: module.Financeiro })))

// Componente de loading
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
)

export function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Institucional />} />
          <Route path="/controladoria" element={<Controladoria />} />
          <Route path="/empresarial" element={<Empresarial />} />
          <Route path="/tributario" element={<Tributario />}/>
          <Route path="/financeiro" element={<Financeiro />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </>
  )
}
